"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const ErrorDisplay = ({ error }) => (react_1.default.createElement(core_1.Tooltip, { title: `Error: ${error}`, "aria-label": `Error: ${error}` },
    react_1.default.createElement(Error_1.default, null)));
exports.default = ErrorDisplay;
//# sourceMappingURL=ErrorDisplay.js.map